import { APP_PREFIX_PATH } from 'configs/AppConfig'

/**
 * Single source of truth for the "Boshqaruv" tree (ТЗ рекомендация №1).
 *
 * Both the sidebar (NavigationConfig) and the reusable department page read
 * from here, so editing a title/description touches text only — never code.
 *
 * Departments 1–4 are "lightweight" delo­proizvodstvo pages: file upload +
 * history, no strict column validation (Вопрос 7). Department 5 is the strict
 * statistics module (schools / teachers Excel templates + ranking, Вопрос 11).
 *
 * Уровень 1 (yuridik) — реальные названия из ТЗ.
 * Уровни 2–4 — черновые узбекские формулировки; правятся здесь же.
 */

// Departments 1–4 live under /app/boshqaruv/<dept>/<sub>
const boshqaruvPath = (deptKey, subKey) =>
	`${APP_PREFIX_PATH}/boshqaruv/${deptKey}/${subKey}`

// Department 5 (statistics) lives under /app/talim/<sub>
const talimPath = (subKey) => `${APP_PREFIX_PATH}/talim/${subKey}`

export const departments = [
	{
		key: 'yuridik',
		code: '1',
		title_uz: "Yuridik xizmat ko'rsatish sho'basi",
		strict: false,
		subsections: [
			{ key: 's1', code: '1.1', title_uz: "Qonun ustuvorligini ta'minlash", desc_uz: "Boshqarma faoliyatida qonun ustuvorligini ta'minlash bo'yicha hujjatlar." },
			{ key: 's2', code: '1.2', title_uz: "Hujjatlarni ekspertizadan o'tkazish", desc_uz: "Shartnoma va me'yoriy hujjatlarni huquqiy ekspertizadan o'tkazish." },
			{ key: 's3', code: '1.3', title_uz: "Murojaatlarni ko'rib chiqish", desc_uz: "Jismoniy va yuridik shaxslar murojaatlarini ko'rib chiqish." },
			{ key: 's4', code: '1.4', title_uz: "Huquqiy savodxonlik", desc_uz: "Xodimlar va aholi o'rtasida huquqiy savodxonlikni oshirish." },
			{ key: 's5', code: '1.5', title_uz: "Sud ishlarini yuritish", desc_uz: "Boshqarma manfaatlarini sud jarayonlarida himoya qilish." },
			{ key: 's6', code: '1.6', title_uz: "Debitorlik-kreditorlik", desc_uz: "Debitorlik va kreditorlik qarzdorligini nazorat qilish." },
		],
	},
	{
		key: 'nazorat',
		code: '2',
		title_uz: "Nazorat-tahlil, ijro intizomi sho'basi",
		strict: false,
		subsections: [
			{ key: 's1', code: '2.1', title_uz: "Ijro intizomi nazorati", desc_uz: "Topshiriq va qarorlar ijrosi intizomini nazorat qilish." },
			{ key: 's2', code: '2.2', title_uz: "Hujjatlar aylanishi tahlili", desc_uz: "Kiruvchi va chiquvchi hujjatlar aylanishini tahlil qilish." },
			{ key: 's3', code: '2.3', title_uz: "Topshiriqlar ijrosi monitoringi", desc_uz: "Yuqori tashkilotlar topshiriqlari ijrosi monitoringi." },
			{ key: 's4', code: '2.4', title_uz: "Hisobotlarni umumlashtirish", desc_uz: "Tuman bo'limlaridan kelgan hisobotlarni umumlashtirish." },
			{ key: 's5', code: '2.5', title_uz: "Faoliyat samaradorligi tahlili", desc_uz: "Boshqarma faoliyati samaradorligi ko'rsatkichlari tahlili." },
		],
	},
	{
		key: 'matbuot',
		code: '3',
		title_uz: "Matbuot kotibi",
		strict: false,
		subsections: [
			{ key: 's1', code: '3.1', title_uz: "Matbuot xabarlari", desc_uz: "Rasmiy matbuot xabarlari va bayonotlarini tayyorlash." },
			{ key: 's2', code: '3.2', title_uz: "OAV bilan ishlash", desc_uz: "Ommaviy axborot vositalari bilan hamkorlik materiallari." },
			{ key: 's3', code: '3.3', title_uz: "Veb-sayt va ijtimoiy tarmoqlar", desc_uz: "Rasmiy veb-sayt va ijtimoiy tarmoqlarni yuritish." },
			{ key: 's4', code: '3.4', title_uz: "Tadbirlarni yoritish", desc_uz: "Boshqarma tadbirlarini ommaviy yoritish materiallari." },
			{ key: 's5', code: '3.5', title_uz: "Foto va video materiallar", desc_uz: "Foto va video materiallar arxivi." },
		],
	},
	{
		key: 'komplayens',
		code: '4',
		title_uz: "Korrupsiyaga qarshi kurashish (komplayens nazorat)",
		strict: false,
		subsections: [
			{ key: 's1', code: '4.1', title_uz: "Korrupsiyaga qarshi choralar rejasi", desc_uz: "Korrupsiyaga qarshi kurashish chora-tadbirlar rejasi." },
			{ key: 's2', code: '4.2', title_uz: "Manfaatlar to'qnashuvi nazorati", desc_uz: "Manfaatlar to'qnashuvi holatlarini aniqlash va nazorat qilish." },
			{ key: 's3', code: '4.3', title_uz: "Xodimlar deklaratsiyalari", desc_uz: "Xodimlar daromadlari to'g'risidagi deklaratsiyalar." },
			{ key: 's4', code: '4.4', title_uz: "Ichki tekshiruvlar", desc_uz: "Ichki komplayens tekshiruvlari natijalari." },
			{ key: 's5', code: '4.5', title_uz: "Komplayens hisobotlari", desc_uz: "Komplayens nazorati bo'yicha davriy hisobotlar." },
		],
	},
	{
		key: 'talim',
		code: '5',
		title_uz: "Umumiy o'rta ta'lim tashkilotlari faoliyatini muvofiqlashtirish",
		strict: true,
		statistics: true,
		subsections: [
			{ key: 'maktablar', code: '5.1', module: 'schools', title_uz: "Maktablar va o'quvchilar", desc_uz: "Tumanlar kesimida maktablar va o'quvchilar statistikasi (Excel shabloni №1)." },
			{ key: 'oqituvchilar', code: '5.2', module: 'teachers', title_uz: "O'qituvchilar", desc_uz: "Tumanlar kesimida o'qituvchilar statistikasi (Excel shabloni №2)." },
			{ key: 'reyting', code: '5.3', module: 'ranking', title_uz: "Tumanlar reytingi", desc_uz: "Tumanlarni o'quvchilar soni va boshqa ko'rsatkichlar bo'yicha reytingi." },
		],
	},
]

// Attach resolved route paths so consumers don't recompute them.
departments.forEach(dept => {
	dept.subsections.forEach(sub => {
		sub.path = dept.statistics
			? talimPath(sub.key)
			: boshqaruvPath(dept.key, sub.key)
	})
})

/** Flat lookup of every subsection by its route path. */
export const findSectionByPath = (pathname) => {
	for (const dept of departments) {
		for (const sub of dept.subsections) {
			if (sub.path === pathname) return { dept, sub }
		}
	}
	return null
}

/** Lookup by dept key + sub key (used by param routes). */
export const findSection = (deptKey, subKey) => {
	const dept = departments.find(d => d.key === deptKey)
	if (!dept) return null
	const sub = dept.subsections.find(s => s.key === subKey)
	if (!sub) return null
	return { dept, sub }
}

export default departments
